import { InventoryFormikValuesDto } from "../InventoryFormikValuesDto";
import { QuantityGetDto } from "svila-common";
import { ChangeStockTransactionDto } from "../ChangeStockTransactionDto";
import { formikToTransactionAddDto } from "./formikToTransactionAddDto";
import { quantityGetDtoToStockTransactionAddDto } from "./quantityGetDtoToStockTransactionAddDto";

export const formikValuesAndItemToChangeStockTransaction = (
  values: InventoryFormikValuesDto,
  template: QuantityGetDto,
  genericProductId: string,
): ChangeStockTransactionDto => {
  const formData = formikToTransactionAddDto(values, genericProductId);
  const templateData = quantityGetDtoToStockTransactionAddDto(template);
  const fullData: ChangeStockTransactionDto = {
    formData,
    templateData,
  };
  return fullData;
};